import React, { useEffect } from 'react';
import { useLocation, useNavigate, UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

function usePrompt(message, when) {
  const location = useLocation();
  const navigate = useNavigate();
  const navigator = React.useContext(NavigationContext).navigator;

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    navigator.push = (...args) => {
      if (window.confirm(message)) {
        push(...args);
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [when, message, navigator]);
}

export default function Prompt({ when, message }) {
  usePrompt(message, when);
  return null;
}